<template>
    <div>
        <modal-monitor v-if="showModal" @close="showModal = false">
            <template v-slot:header>
                Wie lange willst du den
                <span class="font-bold">{{
                        desk?.name || conferenceRoom?.name
                    }}</span>
                reservieren?
            </template>

            <time-picker @selected="bookIt" :maxBookingMinutes="hoursLimit * 60"></time-picker>
        </modal-monitor>
        <modal-monitor v-if="showAlertModal" @close="showAlertModal = false">
            <template v-slot:header> Fehler</template>
            <div class="p-4">
                <p>{{ error }}</p>
            </div>
        </modal-monitor>

        <div class="bg-gray-800 text-white">
            <!-- Visible error display instead of a silent white screen (remote diagnosis of the kiosk) -->
            <div v-if="loadError"
                 style="position: fixed; top: 0; left: 0; width: 100%; z-index: 9999; background-color: #b91c1c; color: #fff; padding: 1rem 1.5rem; font-size: 1rem; line-height: 1.4;">
                <strong>Panel-Fehler:</strong> {{ loadError.context }}
                <template v-if="loadError.status"> (HTTP {{ loadError.status }})</template>
                — {{ loadError.message }}
                <span style="margin-left: 1rem; font-size: .85rem; opacity: .85;">{{ loadError.time }}</span>
                <span v-if="loadError.url" style="margin-left: .5rem; font-size: .85rem; opacity: .85;">[{{ loadError.url }}]</span>
            </div>

            <div>
                <div v-show="desks.length > 0 && !showFullScreenImage"
                     class="grid grid-rows-6 grid-flow-col gap-4 h-screen">
                    <!-- 1 -->
                    <div>
                        <div class="bg-office-primary h-32">
                            <div class="grid grid-cols-2 gap-x-10 mx-8 h-full">
                                <div class="flex my-auto">
                                    <div class="my-auto">
                                        <a :href="`/panels/groups/${groupUuid}?reset=true`">
                                            <img class="h-12" src="/files/logo-2021-white.png" alt="logo"/>
                                        </a>
                                    </div>
                                    <div>
                                        <a v-if="groupLogo" :href="`/panels/groups/${groupUuid}?reset=true`">
                                            <img class="ml-16 h-20" :src="groupLogo" alt="logo"/>
                                        </a>
                                    </div>
                                </div>


                                <div
                                    class="my-auto text-3xl uppercase font-bold tracking-wide text-right text-gray-800">
                                    {{ floor.name }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="ml-6 font-semibold" v-show="touchable"> Tippe auf ein Objekt um es zu buchen <i
                        class="ml-2 fa fa-arrow-down fa-lg animate-bounce office-primary"></i></div>

                    <div id="desk_map" class="mx-auto row-span-4 w-full" style="background-color: transparent"></div>

                    <div class="absolute right-0 mt-32" style="z-index: 5000">
                        <div v-if="touchable" id="floors" class="grid grid-cols-1 gap-4 mt-10 justify-center">
                            <div v-for="floor in floors" :key="floor.uuid">
                                <a :href="`/panels/floors/${floor.uuid}/touch/${touchable}`" class="mr-2">
                                    <button-primary class="w-full">
                                        <template slot="icon">
                                            <i class="fa fa-television"></i>
                                        </template>
                                        {{ floor.name }}
                                    </button-primary>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div>

                        <div class="grid grid-cols-4 gap-4">

                            <div class="col-span-3 flex mx-10">
                                <div class="flex mr-4 items-center">
                                    <div class="w-4 h-4 rounded-full mr-2 bg-green-500"></div>
                                    Verfügbar
                                </div>
                                <div class="flex mx-4 items-center">
                                    <div class="w-4 h-4 rounded-full mr-2 bg-red-500"></div>
                                    Gebucht
                                </div>
                                <div class="flex mx-4 items-center">
                                    <div class="w-4 h-4 rounded-full mr-2 bg-yellow-400"></div>
                                    Demnächst Gebucht
                                </div>
                            </div>

                            <div class="">
                                <div v-for="item in filteredImage" :key="item.name">
                                    <img class="w-32" :src="'/files/' + item.name" :alt="item.name"/>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div v-if="Object.keys(data).length > 0 && data.image_small">
                        <img class="w-full h-full object-cover" :src="'/storage/' + data.image_small" alt=""/>
                    </div>
                </div>

                <div v-show="desks.length > 0 && showFullScreenImage"
                     class="grid grid-rows-6 grid-flow-col gap-4 h-screen">
                    <!-- 1 -->
                    <div>
                        <div class="bg-office-primary h-32">
                            <div class="grid grid-cols-3 mx-8 h-full">
                                <div class="my-auto">
                                    <img class="h-12" src="/files/logo-2021-white.png" alt="logo"/>
                                </div>

                                <div></div>

                                <div
                                    class="my-auto text-3xl uppercase font-bold tracking-wide text-right text-gray-800">
                                    {{ floor.name }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mx-auto row-span-5 w-full">
                        <img class="w-full h-full object-cover" :src="'/storage/' + data.image_large" alt=""/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from "../components/UI/Loading.vue";
import L from "leaflet";
import bookableCategory from "../pages/BookableCategory.vue";
import ButtonPrimary from "../components/UI/ButtonPrimary.vue";
import TimePicker from "../components/TimePicker.vue";
import {addMinutes} from "date-fns";
import ModalMonitor from "../components/ModalMonitor.vue";
import PusherJs from 'pusher-js';

export default {
    name: "floor-panel",
    components: {ModalMonitor, TimePicker, ButtonPrimary, Loading},

    props: ["id", "groupUuid", "groupLogo"],

    data: () => ({
        loading: false,
        error: "",
        loadError: null,
        floor: {},
        floors: [],
        desk: {},
        desks: [],
        bookingMinutes: 30,
        map: null,
        markerLayer: null,
        timer: null,
        availableDesks: "",
        capacity: "",
        conferenceRooms: [],
        conferenceRoom: {},
        bookables: [],
        bookableCategories: [],
        data: [],
        showMainContent: true,
        showFullScreenImage: false,
        timerImage: null,
        currentDate: new Date().toISOString().slice(5, 10),
        showModal: false,
        hoursLimit: 8,
        lastDataHash: null,
        resetTimer: null,
        initialBounds: null,
        images: [
            {name: "winter.png", dateRange: {start: "11-01", end: "11-31"}},
            {
                name: "nicolaus.png",
                dateRange: {start: "12-01", end: "12-30"},
            },
            {name: "winter.png", dateRange: {start: "01-01", end: "01-30"}},
            {name: "clown.png", dateRange: {start: "02-01", end: "02-27"}},
            {
                name: "easter_bunny.png",
                dateRange: {start: "02-28", end: "03-31"},
            },
            {name: "spring.png", dateRange: {start: "04-01", end: "04-30"}},
            {name: "summer.png", dateRange: {start: "05-01", end: "09-15"}},
            {name: "autumn.png", dateRange: {start: "09-16", end: "10-30"}},
        ],
        showAlertModal: false,
    }),

    mounted() {
        this.load();
        localStorage.setItem("floor-panel", this.id);
        this.timer = setInterval(this.load, 20_000);
        this.subscribe();

        // Surface unhandled JS errors + promise rejections (visible/logged) instead of
        // letting the kiosk silently turn white.
        this.onGlobalError = (event) =>
            this.reportError("JavaScript-Fehler", event.error || {message: event.message});
        this.onGlobalRejection = (event) =>
            this.reportError("Unbehandelte Promise-Rejection", event.reason);
        window.addEventListener("error", this.onGlobalError);
        window.addEventListener("unhandledrejection", this.onGlobalRejection);
    },

    beforeDestroy() {
        clearInterval(this.timer);
        if (this.resetTimer) {
            clearTimeout(this.resetTimer);
        }
        window.removeEventListener("error", this.onGlobalError);
        window.removeEventListener("unhandledrejection", this.onGlobalRejection);
    },

    computed: {
        touchable() {
            return this.floor?.panel?.is_touchable;
        },
        showConferenceRooms() {
            return this.floor?.panel?.show_conference_rooms ?? true;
        },
        image() {
            return this.floor?.map_link ?? "";
        },
        filteredImage() {
            return this.images.filter((item) => {
                const {start, end} = item.dateRange;
                return this.currentDate >= start && this.currentDate <= end;
            });
        },
    },

    methods: {
        bookableCategory() {
            return bookableCategory;
        },
        extractMessage(error) {
            return (
                error?.response?.data?.message ??
                error?.message ??
                String(error)
            );
        },
        reportError(context, error) {
            const info = {
                context,
                time: new Date().toLocaleString("de-DE"),
                status: error?.response?.status ?? null,
                message: this.extractMessage(error),
                url: error?.config?.url ?? null,
            };
            this.loadError = info;
            // console.error is captured on the kiosk device and by the Laravel Boost browser logger
            console.error("[FloorPanel]", context, info, error);
        },
        load() {
            this.currentDate = new Date().toISOString().slice(5, 10);
            this.error = "";
            this.loading = true;
            this.$http
                .get(`/panel-data/floors/${this.id}`)
                .then((result) => {
                    // Successful load -> reset any error display
                    this.loadError = null;
                    // Erstelle Hash des gesamten Datenblocks
                    const currentDataHash = this.createDataHash(result.data);

                    // Nur aktualisieren wenn sich die Daten geändert haben
                    if (this.lastDataHash !== currentDataHash) {
                        this.floor = result.data.floor;
                        this.floors = result.data.floors;
                        this.desks = result.data.desks;
                        this.availableDesks = result.data.availableDesks;
                        this.capacity = result.data.capacity;
                        this.conferenceRooms = result.data.conferenceRooms;
                        this.bookables = result.data.bookableCategories
                            .map((bc) => bc.bookables)
                            .flat();
                        this.bookableCategories = result.data.bookableCategories;

                        this.lastDataHash = currentDataHash;

                        // Nur Map initialisieren wenn sie noch nicht existiert
                        if (this.map === null) {
                            this.initMap();
                        } else {
                            this.updateMapData();
                        }
                    }

                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                    this.reportError("Etagendaten laden fehlgeschlagen", error);
                });
        },
        createDataHash(data) {
            // Erstelle einen einfachen Hash aus den relevanten Daten
            const relevantData = {
                desks: data.desks.map(d => ({
                    id: d.id,
                    schedules: d.schedules,
                    type: d.type
                })),
                conferenceRooms: data.conferenceRooms.map(cr => ({
                    id: cr.id,
                    bookings: cr.bookings
                })),
                bookables: data.bookableCategories.map(bc => bc.bookables).flat().map(b => ({
                    id: b.id,
                    schedules: b.schedules || [],
                    bookings: b.bookings || []
                }))
            };

            return JSON.stringify(relevantData);
        },
        updateMapData() {
            // markerLayer holds all interactive layers. clearLayers() removes them including
            // bound tooltips + click listeners completely - more robust than the previous
            // eachLayer/removeLayer, which mutated the layer collection during iteration and
            // could leave layers behind (accumulating memory/DOM).
            if (!this.markerLayer) {
                return;
            }
            this.markerLayer.clearLayers();

            // Füge die aktualisierten Daten hinzu
            this.add();
        },
        initMap() {
            if (this.map != null) {
                this.map.remove();
                this.map = null;
            }

            let img = new Image();

            img.onload = () => {
                let minZoom = -Math.ceil(
                    Math.max(img.width + img.height) / 1000
                );

                this.map = L.map("desk_map", {
                    attributionControl: false,
                    crs: L.CRS.Simple,
                    minZoom: minZoom,
                    maxZoom: 2,
                    zoomSnap: 0.1,
                    zoomControl: false,
                });
                this.createMap(img.width, img.height);
            };

            img.src = this.image;
        },
        createMap(width, height) {
            let bounds = [
                [0, 0],
                [height, width],
            ];
            this.initialBounds = bounds;

            L.imageOverlay(this.image, bounds).addTo(this.map);
            this.map.setMaxBounds(bounds);
            this.map.fitBounds(bounds);

            // Dedicated group for all interactive layers -> enables clean clearLayers()
            this.markerLayer = L.featureGroup().addTo(this.map);

            //Bei einem Zoom oder einem Move, soll die Komponente nach 10Sek resetted werden
            this.map.on("zoomend", this.scheduleResetView);
            this.map.on("moveend", this.scheduleResetView);
            this.add();
        },
        scheduleResetView() {
            // Timer zurücksetzen, falls noch einer läuft
            if (this.resetTimer) {
                clearTimeout(this.resetTimer);
            }

            // Starte neuen Countdown
            this.resetTimer = setTimeout(() => {
                if (this.initialBounds && this.map) {
                    this.map.fitBounds(this.initialBounds, {
                        animate: true,
                        duration: 2, // Sekunden
                        easeLinearity: 1
                    });
                }
            }, 10000);
        },

        add() {
            this.desks.forEach((item) => {
                this.addClickableRectangle(item);
            });

            if (!this.showConferenceRooms) {
                return;
            }

            this.conferenceRooms.forEach((cr) =>
                this.addClickableRectangle(cr)
            );

            this.bookables.forEach((b) => this.addClickableRectangle(b));
        },
        bookIt(minutes) {
            let startDate = new Date();
            let begin = startDate.getHours();
            let end = addMinutes(startDate, minutes).getHours();
            if (this.desk) {
                this.$http
                    .post("/panels/floors/desk", {
                        from: startDate,
                        to: startDate,
                        uuid: this.desk.uuid,
                        id: this.desk.id,
                        begin,
                        end,
                        user: null,
                    })
                    .then(() => {
                        this.showModal = false;
                        this.loading = false;
                        this.$root.$emit("alert", "Buchung erstellt.");
                        this.load();
                    })
                    .catch((error) => {
                        this.loading = false;
                        this.showModal = false;
                        this.showAlertModal = true;
                        this.error = this.extractMessage(error);
                    });
            } else {
                let start = `${startDate.getFullYear()}-${(
                    startDate.getMonth() + 1
                )
                    .toString()
                    .padStart(2, "0")}-${startDate
                    .getDate()
                    .toString()
                    .padStart(2, "0")} ${startDate
                    .getHours()
                    .toString()
                    .padStart(2, "0")}:${startDate
                    .getMinutes()
                    .toString()
                    .padStart(2, "0")}`;
                end = `${addMinutes(startDate, minutes).getFullYear()}-${(
                    addMinutes(startDate, minutes).getMonth() + 1
                )
                    .toString()
                    .padStart(2, "0")}-${addMinutes(startDate, minutes)
                    .getDate()
                    .toString()
                    .padStart(2, "0")} ${addMinutes(startDate, minutes)
                    .getHours()
                    .toString()
                    .padStart(2, "0")}:${addMinutes(startDate, minutes)
                    .getMinutes()
                    .toString()
                    .padStart(2, "0")}`;
                let params = {
                    start,
                    end,
                    conference_room_id: this.conferenceRoom.id,
                    user_id: "guest",
                };
                window.axios
                    .post("/panels/floors/conferenceRoom", params)
                    .then(() => {
                        this.showModal = false;
                        this.loading = false;
                        this.$root.$emit("alert", "Buchung erstellt.");
                        this.load();
                    })
                    .catch((error) => {
                        this.loading = false;
                        this.showModal = false;
                        this.showAlertModal = true;
                        this.error = this.extractMessage(error);
                    });
            }
        },
        determineDeskStatus(item) {
            if (item.type === "disabled") {
                return "red";
            }

            if (item.schedules.length === 0) {
                return "green";
            }

            let ss = item.schedules.map((schedule) => {
                const from = new Date(schedule.from);
                const to = new Date(schedule.to);
                const now = new Date();
                if (from < now && now < to) {
                    return "red";
                }

                // it's yellow, if the schedule is in the future and starts in the next 60 minutes
                if (
                    from > now &&
                    from.getTime() - now.getTime() / 1000 / 60 < 60
                ) {
                    return "yellow";
                }

                return "green";
            });

            if (ss.find((item) => item === "red")) {
                return "red";
            }
            if (ss.find((item) => item === "yellow")) {
                return "yellow";
            }

            return "green";
        },
        determineAvatar(item, subArray = "schedules") {
            let short = null;

            if (item[subArray].length) {
                if (item[subArray][0].user) {
                    let s =
                        item[subArray][0]?.user?.first_name?.substring(0, 1) +
                        item[subArray][0]?.user?.name?.substring(0, 1);
                    short = s ? s.toUpperCase() : "";
                    if (item[subArray][0].user.avatar) {
                        short = `<div class="avatar-div"><img class="rounded-full" style="width: 2rem; max-height: 2rem; aspect-ratio: 1 / 1;" src='${item[subArray][0].user.avatar}' alt='${short}' /></div>`;
                    }
                } else {
                    short = "Gast";
                }
            }

            if (item.owner) {
                let s =
                    item.owner.first_name?.substring(0, 1) +
                    item.owner.name?.substring(0, 1);
                short = s ? s.toUpperCase() : "";
                if (item.owner.avatar) {
                    short = `<div class="avatar-div"><img class="rounded-full w-full h-full" src='data:image/jpeg;base64,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' alt='${short}' /></div>`;
                }
            }

            return short;
        },
        determineColor(status) {
            switch (status) {
                case "red":
                    return "red";
                case "yellow":
                    return "yellow";
                case "green":
                    return "#10B981";
                default:
                    return "black";
            }
        },
        determineStatus(item) {
            if (item.bookings.length === 0) {
                return "green";
            }

            let ss = item.bookings.map((booking) => {
                const from = new Date(booking.start);
                const to = new Date(booking.end);
                const now = new Date();
                if (from < now && now < to) {
                    return "red";
                }
                // jetzt 15:02, ab 15:32 gebucht: ab 15:02 gelb, vor 15:02 grun, ab 15:32 rot
                let d = new Date(now);
                if (
                    from <= new Date(d.setMinutes(now.getMinutes() + 30)) &&
                    from >= now
                ) {
                    return "yellow";
                }

                return "green";
            });

            if (ss.find((item) => item === "red")) {
                return "red";
            }
            if (ss.find((item) => item === "yellow")) {
                return "yellow";
            }

            return "green";
        },
        addClickableRectangle(item) {
            if (!item.map.position) {
                return;
            }

            let layer;
            let color = null;
            let short = "";

            if (item.schedules) {
                // item is of type desk and has schedules
                let status = this.determineDeskStatus(item);
                color = this.determineColor(status);
                if (status === "red") {
                    short = this.determineAvatar(item, "schedules");
                }
            } else {
                // conference room
                let status = this.determineStatus(item);
                color = this.determineColor(status);
                if (status === "red") {
                    short = this.determineAvatar(item, "bookings");
                }
            }

            layer = this.drawItem(item.map, color);

            if (short) {
                layer.bindTooltip(short, {
                    permanent: true,
                    className: "myTooltip",
                    offset: [0, 0],
                    direction: "center",
                    interactive: true,
                });
            }

            layer.addTo(this.markerLayer).on("click", (e) => {
                const id = item.id;

                this.desk = this.desks.find((desk) => desk.id === id);

                if (this.desk?.type === "disabled") {
                    this.showModal = false;
                    return;
                }

                this.conferenceRoom = this.desk
                    ? null
                    : this.conferenceRooms.find((cr) => cr.id === id);

                const entity = this.desk || this.conferenceRoom;
                const scheduleKey = this.desk ? "schedules" : "bookings";

                if (entity) {
                    const nextBooking = this.findNextBookingToday(
                        entity,
                        scheduleKey
                    );
                    this.hoursLimit = nextBooking
                        ? new Date(nextBooking).getHours() -
                        new Date().getHours()
                        : 24 - new Date().getHours();
                    this.showModal = !this.hasBookingNow(entity, scheduleKey);
                } else {
                    this.showModal = false;
                }
            });
        },
        drawItem(item, color) {
            if (item.position.type === 'circle') {
                return L.circle(item.position.center, {
                    color: color,
                    radius: item.position.radius,
                    weight: 1,
                    id: item.id,
                });
            }

            let rect = L.rectangle(
                [
                    [
                        item.position.center[0] + item.position.height,
                        item.position.center[1] - item.position.width,
                    ],
                    [
                        item.position.center[0] - item.position.height,
                        item.position.center[1] + item.position.width,
                    ],
                ],
                {color: color, weight: 1, id: item.id}
            );
            this.rotateRectangle(item, rect);
            return rect;
        },
        rotateRectangle(item, rectangle) {
            if (!rectangle || !item.position) {
                return;
            }
            let center = rectangle.getBounds().getCenter();
            let rotationRadians = (item.position.angle * Math.PI) / 180;
            let rotatedCorners = rectangle.getLatLngs()[0].map((corner) => {
                return this.rotatePoint(corner, center, rotationRadians);
            });

            rectangle.setLatLngs([rotatedCorners]);
        },
        rotatePoint(point, center, angle) {
            let x =
                center.lng +
                (point.lng - center.lng) * Math.cos(angle) -
                (point.lat - center.lat) * Math.sin(angle);
            let y =
                center.lat +
                (point.lng - center.lng) * Math.sin(angle) +
                (point.lat - center.lat) * Math.cos(angle);
            return L.latLng(y, x);
        },
        hasBookingNow(entity, scheduleKey) {
            if (!entity) return false;
            let now = new Date();

            return entity[scheduleKey].some((schedule) => {
                let from = new Date(schedule.from || schedule.start);
                let to = new Date(schedule.to || schedule.end);
                return now >= from && now <= to;
            });
        },
        findNextBookingToday(entity, scheduleKey) {
            if (!entity) return null;
            let now = new Date();
            let endOfDay = new Date(now);
            endOfDay.setHours(23, 59, 59, 999);
            let earliestBooking = null;

            entity[scheduleKey].forEach((schedule) => {
                let from = new Date(schedule.from || schedule.start);

                if (from > now && from <= endOfDay) {
                    if (!earliestBooking || from < earliestBooking) {
                        earliestBooking = from;
                    }
                }
            });

            return earliestBooking;
        },
        subscribe() {
            let client = new PusherJs('xTUlJRGREQ0NBbHlnQXdJQkFnSUdBWXNZZW', {
                wsHost: 'ws.parkefficient.de',
                wsPort: 443,
                wssPort: 443,
                forceTLS: true,
                encrypted: true,
                disableStats: true,
                enabledTransports: ['ws', 'wss'],
                cluster: 'eu',
            });

            client
                .subscribe('Floors.' + this.id)
                .bind('App\\Events\\FloorUpdatedEvent', (event) => {
                    this.floor.name = event.name;
                });
        },
    },
};
</script>

<style scoped>
.leaflet-tooltip {
    padding: 0 !important;
    margin: 0 !important;
}

.checkedIn {
    background-color: #10B981 !important;
    border: 1px solid #10B981 !important;
}

.avatar-div {
    display: inline-flex;
    align-items: center;
    padding: 0;
    margin: 0;
    width: 20px;
    height: 20px;
    font-size: 12px;
    text-align: center;
}

#desk_map {
    z-index: 1;
}

/* Background Colors */
.bg-gray-800 {
    background-color: #1f2937;
}
.bg-office-primary {
    background-color: #f8b241;
}
.bg-green-500 {
    background-color: #22c55e;
}
.bg-red-500 {
    background-color: #ef4444;
}
.bg-yellow-400 {
    background-color: #facc15;
}

/* Text Colors */
.text-white {
    color: #ffffff;
}
.text-gray-800 {
    color: #1f2937;
}
.office-primary {
    color: #f8b241;
}

/* Layout - Grid */
.grid {
    display: -ms-grid;
    display: grid;
}
.grid-rows-6 {
    -ms-grid-rows: (minmax(0, 1fr))[6];
    grid-template-rows: repeat(6, minmax(0, 1fr));
}
.grid-flow-col {
    grid-auto-flow: column;
}
.grid-cols-1 {
    -ms-grid-columns: minmax(0, 1fr);
    grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
    -ms-grid-columns: (minmax(0, 1fr))[2];
    grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
    -ms-grid-columns: (minmax(0, 1fr))[3];
    grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
    -ms-grid-columns: (minmax(0, 1fr))[4];
    grid-template-columns: repeat(4, minmax(0, 1fr));
}
.col-span-3 {
    -ms-grid-column-span: 3;
    grid-column: span 3 / span 3;
}
.row-span-4 {
    -ms-grid-row-span: 4;
    grid-row: span 4 / span 4;
}
.row-span-5 {
    -ms-grid-row-span: 5;
    grid-row: span 5 / span 5;
}

/* Layout - Flexbox */
.flex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}
.justify-center {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
.items-center {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

/* Gap */
.gap-4 {
    gap: 1rem;
}
.gap-x-10 {
    -webkit-column-gap: 2.5rem;
    -moz-column-gap: 2.5rem;
    column-gap: 2.5rem;
}

/* Positioning */
.absolute {
    position: absolute;
}
.right-0 {
    right: 0;
}

/* Sizing */
.h-screen {
    height: 100vh;
}
.h-full {
    height: 100%;
}
.h-32 {
    height: 8rem;
}
.h-20 {
    height: 5rem;
}
.h-12 {
    height: 3rem;
}
.h-4 {
    height: 1rem;
}
.w-full {
    width: 100%;
}
.w-32 {
    width: 8rem;
}
.w-4 {
    width: 1rem;
}
.w-8 {
    width: 2rem;
}
.max-h-8 {
    max-height: 2rem;
}
.aspec {
    aspect-ratio: 1 / 1;
}

/* Spacing - Margin */
.mx-auto {
    margin-left: auto;
    margin-right: auto;
}
.my-auto {
    margin-top: auto;
    margin-bottom: auto;
}
.mx-4 {
    margin-left: 1rem;
    margin-right: 1rem;
}
.mx-8 {
    margin-left: 2rem;
    margin-right: 2rem;
}
.mx-10 {
    margin-left: 2.5rem;
    margin-right: 2.5rem;
}
.ml-2 {
    margin-left: 0.5rem;
}
.ml-6 {
    margin-left: 1.5rem;
}
.ml-16 {
    margin-left: 4rem;
}
.mr-2 {
    margin-right: 0.5rem;
}
.mr-4 {
    margin-right: 1rem;
}
.mt-10 {
    margin-top: 2.5rem;
}
.mt-32 {
    margin-top: 8rem;
}

/* Spacing - Padding */
.p-4 {
    padding: 1rem;
}

/* Typography */
.text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
}
.font-bold {
    font-weight: 700;
}
.font-semibold {
    font-weight: 600;
}
.uppercase {
    text-transform: uppercase;
}
.tracking-wide {
    letter-spacing: 0.025em;
}
.text-right {
    text-align: right;
}

/* Border */
.rounded-full {
    -webkit-border-radius: 9999px;
    -moz-border-radius: 9999px;
    border-radius: 9999px;
}

/* Object Fit */
.object-cover {
    -o-object-fit: cover;
    object-fit: cover;
}

/* Animation */
@-webkit-keyframes bounce {
    0%, 100% {
        -webkit-transform: translateY(-25%);
        transform: translateY(-25%);
        -webkit-animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
        animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
    }
    50% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        -webkit-animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
        animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
    }
}
@keyframes bounce {
    0%, 100% {
        -webkit-transform: translateY(-25%);
        transform: translateY(-25%);
        -webkit-animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
        animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
    }
    50% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        -webkit-animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
        animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
    }
}
.animate-bounce {
    -webkit-animation: bounce 1s infinite;
    animation: bounce 1s infinite;
}
</style>
